import { get } from 'lodash';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '../../../services/api';
import history from '../../../services/history';
import { loginFailure, loginSuccess } from './actions';
import { AuthTypes } from './types';

function* loginRequest({ payload }: any): Generator<any> {
  try {
    const response: any = yield call(api.post, 'v1/backoffice/admins/login', {
      email: payload.email,
      password: payload.password,
    });

    yield put(loginSuccess(response.data));

    api.defaults.headers.Authorization = `Bearer ${response.data}`;

    history.push('/home/dashboard-admin');
  } catch (e) {
    const error: AxiosError = e as AxiosError;
    toast.error(error.response?.data.message);
    toast.clearWaitingQueue();
    yield put(loginFailure({}));
  }
}

function persistRehydrate({ payload }: any) {
  const token = get(payload, 'auth.token', '');
  if (!token) return;

  api.defaults.headers.Authorization = `Bearer ${token}`;
}
export default all([
  takeLatest(AuthTypes.LOGIN_REQUEST, loginRequest),
  takeLatest(AuthTypes.PERSIST_REHYDRATE, persistRehydrate),
]);
